import Phaser from 'phaser';
import BalloonFlying from '../animations/balloon-flying';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

const Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = {};
  this.difficulty = 1;
  this.iteration = 0;
  this.positions = [];
  this.balloons = [];
  this.balloonsFlyingAnimations = [];
  this.dropZones = [];
  this.signs = [];
  this.pairs = [];
  this.groupFly = null;
  this.groupDrag = null;
  this.groupLock = null;
  this.lightning = null;
  this.templateUI = [];
};

Main.prototype = Object.create(BaseMinigamesMain.prototype);
Main.prototype.constructor = Main;

const MB = Main.prototype;

MB.generateSignsPositions = function () {
  const { pairsCount } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  this.pairs = this.shufflePairs();
  this.positions = [];
  const slotWidth = Math.round(this.game.config.width / this.pairs.length);
  const baseY = 830;
  const maxOffset = 30;
  for (let i = 0; i < this.pairs.length; i++) {
    const x = slotWidth * i + Math.round(slotWidth / 2);
    const y = baseY + Math.floor(Math.random() * maxOffset);
    this.positions.push(new Phaser.Geom.Point(x, y));
  }
};

MB.shufflePairs = function () {
  const { pairsCount } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { pairs } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let j; let x; let i;
  const array = [];
  const array2 = [];
  for (i = 0; i < pairs.length; i++) {
    array.push(pairs[i]);
  }
  for (i = array.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = array[i];
    array[i] = array[j];
    array[j] = x;
  }
  for (i = 0; i < pairsCount; i++) {
    array2.push(array[i]);
  }
  return array2;
};

MB.create = function () {
  this.initialize();

  this.loadIteration();

  this.createBasicUI();
};

MB.loadIteration = function () {
  this.createTemplateUI();
  this.generateSignsPositions();
  this.groupLock = this.add.container(0, 0);
  this.addSigns();
  this.lightning = this.add.sprite(0, 0, 'lightning');
  this.lightning.setAlpha(0);
  this.groupFly = this.add.container(0, 0);
  this.addBalloons();
  this.groupDrag = this.add.container(0, 0);
};

MB.createTemplateUI = function () {
  let title; let instructions;
  const { titleImg } = this.gameConfig;
  const { instructionsImg } = this.gameConfig;
  if (titleImg) {
    title = this.add
      .sprite(this.game.config.width / 2, 1015, 'title')
      .setOrigin(0.5)
      .setDepth(1);
  } else {
    const titleFont = {
      font: `${this.gameConfig.titleSize} ${this.gameConfig.font}`,
    };
    title = this.add
      .text(this.game.config.width / 2, 1015, this.gameConfig.titleTxt, titleFont)
      .setOrigin(0.5)
      .setDepth(1);
  }

  if (instructionsImg) {
    instructions = this.add
      .sprite(30, 50, 'instructions')
      .setOrigin(0)
      .setDepth(1);
  } else {
    instructions = this.make
      .text({
        x: 30,
        y: 50,
        text: this.gameConfig.instructionsTxt,
        origin: { x: 0, y: 0 },
        style: {
          fontFamily: `${this.gameConfig.font}`,
          fontSize: `${this.gameConfig.instructionsSize}`,
          wordWrap: { width: `${this.gameConfig.instructionsMaxWidth}` },
          lineSpacing: 15,
        },
      })
      .setDepth(1);
  }
  this.templateUI.push(title);
  this.templateUI.push(instructions);
};
/**
 *
 */
MB.addSigns = function () {
  for (let i = 0; i < this.pairs.length; i++) {
    const pos = this.positions[i];
    const container = this.add.container(pos.x, pos.y);
    const sign = this.add.sprite(0, 0, 'wood-sign');
    container.setData('colorName', this.pairs[i]);
    container.add(sign);

    this.signs.push(container);

    const bounds = container.getBounds();
    const zh = 475;
    const zone = new Phaser.Geom.Rectangle(bounds.x - 35,
      bounds.y - zh + bounds.height + 125, bounds.width + 70, zh);
    this.dropZones.push(zone);

    this.addLabel(container, this.pairs[i]);
  }
};

MB.addLabel = function (signContainer, colorName) {
  const label = this.add.sprite(0, 0, `sign-${colorName}`);
  signContainer.add(label);
};

MB.addBalloons = function () {
  // const ballonsSlotWidth = (this.game.config.width - 40) / this.pairs.length;
  for (let i = 0; i < this.pairs.length; i++) {
    // const x = ballonsSlotWidth / 2 + ballonsSlotWidth * i;
    const balloon = this.add.sprite(0, 0, `balloon-${this.pairs[i]}`);
    balloon.setData('index', i);
    balloon.setData('colorName', this.pairs[i]);
    balloon.setInteractive();

    this.cursorManager.setDefaultDraggableEvents(balloon);

    this.input.setDraggable(balloon);

    balloon.on(
      'drag',
      ((balloonSprite, pointer, dragX, dragY) => {
        balloonSprite.x = dragX;
        balloonSprite.y = dragY;
      }).bind(this, balloon),
      this,
    );

    balloon.on('dragstart', this.onDragStart.bind(this, balloon), this);
    balloon.on('dragend', this.onDragStop.bind(this, balloon), this);
    this.balloons.push(balloon);
    const flyAnim = new BalloonFlying(this, balloon);
    this.balloonsFlyingAnimations.push(flyAnim);
    flyAnim.start();

    this.groupFly.add(balloon);
  }
};

MB.onDragStart = function (balloon) {
  const idx = balloon.getData('index');
  this.balloonsFlyingAnimations[idx].stop();
  this.groupDrag.add(balloon);
};

MB.turnBalloonsDragAbility = function (isEnabled) {
  for (let i = 0; i < this.balloons.length; i++) {
    if (isEnabled) {
      this.input.setDraggable(this.balloons[i]);
    } else {
      this.input.setDraggable(this.balloons[i], false);
    }
  }
};

MB.onDragStop = function (balloon, pointer) {
  for (let i = 0; i < this.dropZones.length; i++) {
    const zone = this.dropZones[i];
    if (zone.contains(pointer.position.x, pointer.position.y)) {
      this.groupLock.add(balloon);
      const bounds = this.signs[i].getBounds();
      balloon.x = bounds.x + bounds.width / 2;
      balloon.y = bounds.y - balloon.height / 2 + 30;
      if (this.signs[i].getData('colorName') === balloon.getData('colorName')) {
        balloon.disableInteractive();
        this.playCorrect();
        this.checkSequence();
        return;
      }
      this.playWrong();
      this.showWrong(i, balloon);
      return;
    }
  }
  const idx = balloon.getData('index');
  this.balloonsFlyingAnimations[idx].backToFlying();
  this.groupFly.add(balloon);
};
/**
 *
 */
MB.showWrong = function (index, balloon) {
  const sign = this.signs[index];
  sign.add(this.lightning);
  this.lightning.alpha = 1;
  this.turnBalloonsDragAbility(false);
  this.tweens.add({
    targets: this.lightning,
    alpha: 0,
    duration: 150,
    ease: 'Sine.easeInOut',
    repeat: 3,
    yoyo: true,
    onComplete: function (target) {
      this.turnBalloonsDragAbility(true);
      const idx = target.getData('index');
      this.balloonsFlyingAnimations[idx].backToFlying();
      this.groupFly.add(target);
      this.lightning.alpha = 0;
    }.bind(this, balloon),
  });

  sign.angle = -5;

  this.tweens.add({
    targets: sign,
    angle: 5,
    duration: 60,
    ease: 'Sine.easeInOut',
    repeat: 6,
    yoyo: true,
    onComplete: function (target) {
      target.angle = 0;
    }.bind(this, sign),
  });
};
/**
 *
 */
MB.checkSequence = function () {
  if (this.groupLock.getAll().length === this.pairs.length) {
    this.time.delayedCall(2000, this.nextIteration, [], this);
    // this.showSummary();
  }
};

MB.nextIteration = function () {
  this.positions = [];
  this.balloons.map((x) => {
    x.destroy();
    return true;
  });
  this.balloons = [];
  this.balloonsFlyingAnimations.map((x) => {
    x.stop();
    return true;
  });
  this.balloonsFlyingAnimations = [];
  this.dropZones = [];
  this.signs.map((x) => {
    x.destroy();
    return true;
  });
  this.signs = [];
  this.templateUI.map((x) => {
    x.destroy();
    return true;
  });
  this.templateUI = [];
  this.pairs = [];
  this.groupFly = null;
  this.groupDrag = null;
  this.groupLock = null;
  this.lightning.destroy();
  this.lightning = null;
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

export default Main;
